@if (!hidden) {
  <footer class="v2 footer">
    <div class="wrap">
      <div class="top">
        <div class="brand">
          <a class="logo" routerLink="/" aria-label="Moderna Media – til forsiden">
            <img src="/assets/Images/LogoV2/modernamedia-plain.svg" width="82" height="30" loading="lazy" alt="" />
            <span class="name">MODERNA MEDIA</span>
          </a>
          <p class="about">Digitalbyrå i Oslo som lager nettsider, design og SEO som gir bedriften din vekst og flere kunder.</p>
          <div class="social">
            <a href="https://www.facebook.com/ModernaMedia" target="_blank" rel="noopener">Facebook</a>
            <a href="https://www.instagram.com/moderna_media/" target="_blank" rel="noopener">Instagram</a>
            <a href="https://www.linkedin.com/company/moderna-media" target="_blank" rel="noopener">LinkedIn</a>
          </div>
        </div>
        @for (col of columns; track col.title) {
          <nav [attr.aria-label]="col.title">
            <h2 class="h4"><a [routerLink]="col.url">{{ col.title }}</a></h2>
            <ul>
              @for (l of col.links; track l[1]) {
                <li><a [routerLink]="l[1]">{{ l[0] }}</a></li>
              }
            </ul>
          </nav>
        }
        <div class="footer-contact">
          <h2 class="h4">Kontakt</h2>
          <ul>
            <li><a href="tel:+4790265326">902 65 326</a></li>
            <li><a href="mailto:kontakt@modernamedia.no">kontakt&#64;modernamedia.no</a></li>
            <li>Oscars gate 76b, Oslo</li>
            <li><a routerLink="/gratis-hjemmeside-analyse">Gratis nettside-analyse</a></li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <span>© {{ year }} Moderna Media, org.nr. 926 670 018. Alle priser er oppgitt eks. mva.</span>
        <div><a routerLink="/personvern">Personvern</a><a routerLink="/kontakt">Kontakt</a></div>
      </div>
    </div>
  </footer>
}
